import React, {
  createContext, useState, ReactNode
} from 'react'
import QuestionKey from '../../Questions/question-key'

export interface YearsMonthsDuration {
  years: number
  months: number
}
interface PrefillReviewPageApplicationFormContextType {
  showReviewPage: boolean
  setShowReviewPage: React.Dispatch<React.SetStateAction<boolean>>
  // Used for Navigation purposes only since duration within employmentHistoryEntryReducer & addressHistoryEntryReducer is lost when entryId changes
  employmentDuration: { [entryId: string]: YearsMonthsDuration }
  setEmploymentDuration: React.Dispatch<React.SetStateAction<{ [entryId: string]: YearsMonthsDuration }>>
  addressDuration: { [entryId: string]: YearsMonthsDuration }
  setAddressDuration: React.Dispatch<React.SetStateAction<{ [entryId: string]: YearsMonthsDuration }>>
  // Used for Logging purposes only since questionConfig is not available with hard-coding the different sections
  questionName: QuestionKey | ''
  setQuestionName: React.Dispatch<React.SetStateAction<string>>
  prevQuestionName: QuestionKey | ''
  experimentName: string
  setExperimentName: React.Dispatch<React.SetStateAction<string>>
  // Used for reviewPageV3 Navigation
  requiredEntryId: string,
  setRequiredEntryId: React.Dispatch<React.SetStateAction<string>>
  hasNavigatedFromRequiredClick: boolean
  setHasNavigatedFromRequiredClick: React.Dispatch<React.SetStateAction<boolean>>
}

interface PrefillReviewPageApplicationFormProviderProps {
  children: ReactNode;
}

export const PrefillReviewPageApplicationFormContext = createContext<PrefillReviewPageApplicationFormContextType>({
  showReviewPage: true,
  setShowReviewPage: () => {},
  employmentDuration: {},
  setEmploymentDuration: () => {},
  addressDuration: {},
  setAddressDuration: () => {},
  questionName: '',
  setQuestionName: () => {},
  prevQuestionName: '',
  experimentName: '',
  setExperimentName: () => {},
  requiredEntryId: '',
  setRequiredEntryId: () => {},
  hasNavigatedFromRequiredClick: false,
  setHasNavigatedFromRequiredClick: () => {}
})

export const PrefillReviewPageApplicationFormProvider: React.FC<PrefillReviewPageApplicationFormProviderProps> = ({
  children
}: PrefillReviewPageApplicationFormProviderProps) => {
  const [showReviewPage, setShowReviewPage] = useState(true)
  const [employmentDuration, setEmploymentDuration] = useState<{ [entryId: string]: YearsMonthsDuration }>({})
  const [addressDuration, setAddressDuration] = useState<{ [entryId: string]: YearsMonthsDuration }>({})
  const [{ questionName, prevQuestionName }, setQuestionNames] = useState<{ questionName: QuestionKey | '', prevQuestionName: QuestionKey | '' }>({ questionName: '', prevQuestionName: '' })
  const [experimentName, setExperimentName] = useState('')
  const [requiredEntryId, setRequiredEntryId] = useState('')
  const [hasNavigatedFromRequiredClick, setHasNavigatedFromRequiredClick] = useState(false)

  const setQuestionNameAndUpdatePrev = (newQuestionName: QuestionKey | '') => {
    setQuestionNames((names) => {
      if (names.questionName === newQuestionName && names.prevQuestionName === names.questionName) return names
      return { questionName: newQuestionName, prevQuestionName: names.questionName }
    })
  }

  return (
    <PrefillReviewPageApplicationFormContext.Provider
      value={{
        showReviewPage,
        setShowReviewPage,
        employmentDuration,
        setEmploymentDuration,
        addressDuration,
        setAddressDuration,
        questionName,
        // TODO: Fix typescript error
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setQuestionName: setQuestionNameAndUpdatePrev,
        prevQuestionName,
        experimentName,
        setExperimentName,
        requiredEntryId,
        setRequiredEntryId,
        hasNavigatedFromRequiredClick,
        setHasNavigatedFromRequiredClick
      }}
    >
      {children}
    </PrefillReviewPageApplicationFormContext.Provider>
  )
}
